import * as React from 'react';
import {
  Wrapper, SpacedParagraph, AllGeniusWrapper, GeniusWrapper, NameParagraph, JobParagarph, GeniusImageWrapper
} from './SectionGenius.s';
import { SectionContent } from '@components/Sections/Sections.s';
import { HeadingCenter } from '@components/Typos/Typos.s';

type SectionGeniusProps = {
  innerRef?: (el: HTMLElement) => void;
};

export const SectionGenius = (props: SectionGeniusProps) => (
  <Wrapper innerRef={props.innerRef}>
    <SectionContent>
      <HeadingCenter>Qui sommes-nous ?</HeadingCenter>
      <SpacedParagraph>Projet réalisé dans le cadre du master DMII à Gobelins, Paris.</SpacedParagraph>
      <AllGeniusWrapper>
        <GeniusWrapper>
          <GeniusImageWrapper src={require('./medias/lena.png')} />
          <NameParagraph>Léna</NameParagraph>
          <JobParagarph>designer</JobParagarph>
        </GeniusWrapper>
        <GeniusWrapper>
          <GeniusImageWrapper src={require('./medias/clement.png')} />
          <NameParagraph>Clément</NameParagraph>
          <JobParagarph>designer</JobParagarph>
        </GeniusWrapper>
        <GeniusWrapper>
          <GeniusImageWrapper src={require('./medias/kirgan.png')} />
          <NameParagraph>Kirgan</NameParagraph>
          <JobParagarph>développeur</JobParagarph>
        </GeniusWrapper>
        <GeniusWrapper>
          <GeniusImageWrapper src={require('./medias/etienne.png')} />
          <NameParagraph>Etienne</NameParagraph>
          <JobParagarph>développeur</JobParagarph>
        </GeniusWrapper>
      </AllGeniusWrapper>
    </SectionContent>
  </Wrapper>
);



// WEBPACK FOOTER //
// src/app/src/components/SectionGenius/SectionGenius.tsx